// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import UserOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UserOutlined';
export default { UserOutlined };
